export const SERVICES_AVAILABLE = 'SERVICES_AVAILABLE';
